const PolicyContent = () => {
  return (
    <div className="flex-1 space-y-4 max-w-full mx-6  lg:mx-0 pt-2 ">
      <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
        When you use Jumaconnect's Services, you are entrusting us with your
        personal information. We understand this is a big responsibility and we
        work hard to make sure we keep your personal information safe. This
        Privacy Policy is meant to help you understand the personal information
        we collect, how we collect, store, process, and share it.
      </p>

      {/* 1. The Information We Collect */}
      <section id="information-we-collect" className=" md:scroll-mt-[120px] scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal text-dark">
           The Information We Collect
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We collect information from you when you register on our service, as a
          Service Provider or Client, or fill out a form. When requesting or
          registering for our service, as appropriate, you may be asked to enter
          your name, e-mail address, home or office address, physical address,
          your GPS location, credit card information, mobile money information.
          You may also use some limited features of our service anonymously,
          however, you cannot use all features in full without supplying our
          systems with the information required.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We collect your personal information to enable us to provide and
          improve our services to you. Personal information is any information
          that we can use to identify, locate, connect and contact you. We
          collect this directly or indirectly when you use our website and other
          interfaces including SMS and USSD. We may also collect your personal
          information from third parties where that information is public or
          with your consent.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We may collect the following types of personal information:
          <ul className="font-inter font-normal text-base leading-6 tracking-normal text-justify  list-disc pl-6">
            <li>
              <b>User information</b> - such as your name, username, home or
              office address, telephone number, email address, or date of birth
              that allow us to provide you with our services and communicate
              with you.
            </li>
            <li>
              <b>Payment method information</b> - helps us to know your bankers
              or money transaction service providers. It enables us to be sure
              that the payments you make are verified as coming from accounts or
              wallets that belong to your person. These include your payment
              medium number, the location of the transaction, the time and date
              of the transaction, the kind of payment you are making, and the
              amount you are paying for the product or service.
            </li>
            <li>
              <b>Information about your interactions with Jumaconnect</b> - such
              as data collected when you use our website (including your IP
              address, metadata on your preferences, GPS location, usage
              patterns, and other information collected using cookies and other
              data collection technologies).
            </li>
          </ul>
        </p>
      </section>
      {/* 2. How We Process Your Personal Information */}
      <section id="process-personal-info" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           How We Process Your Personal Information
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          Any of the information we collect from you may be used in one of the
          following ways:
        </p>
        <ul className="font-inter font-normal text-base leading-6 tracking-normal text-justify  list-disc pl-6 text-content">
          <li>
            To personalize your experience - as your information helps us to
            better respond to your specific needs.
          </li>
          <li>
            To improve our website and systems - we continually strive to
            improve our website offerings based on the information and feedback
            we receive from you.
          </li>
          <li>
            To improve customer service - as your information helps us to more
            effectively respond to your customer service requests and support
            needs.
          </li>
          <li>
            To process transactions - as your information, whether public or
            private, will not be sold, exchanged, transferred, or given to any
            other company for any reason whatsoever, without your consent, other
            than for the express purpose of delivering the purchased product or
            service requested.
          </li>
          <li>
            To send periodic SMS, push notifications, and emails - The contact
            information you provide for order processing will only be used to
            send you information and updates on your order.
          </li>
          <li>
            To provide you with additional information - such as product updates
            and most important news and/or announcements.
          </li>
          <li>
            To provide you with marketing communication - for products and
            services from us and our affiliates, including personalized offers
            and content based on your interactions with us and usage of our
            services.
          </li>
          <li>
            To generate aggregated datasets - that do not reveal your personal
            information. We may use these datasets to create models, generate
            reports, and analyze payment transactions or other trends.
          </li>
        </ul>
      </section>

      {/* 3. How We Share Your Personal Information */}
      <section id="share-info" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           How We Share Your Personal Information
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We do not sell, trade, or otherwise transfer to outside parties your
          personally identifiable information.
        </p>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          This does not include trusted third parties who assist us in operating
          our website, conducting our business,
          <br /> or servicing you, so long as those parties agree to keep this
          information confidential.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We may also release your information when we believe release is
          appropriate to comply with the law, enforce our site policies, or
          protect our or others' rights, property, or safety. However,
          non-personally identifiable visitor information may be provided to
          other parties for marketing, advertising, or other uses.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We may include or offer third-party products or services across our
          features and website. These third-party services have separate and
          independent privacy policies. We, therefore, have no responsibility or{" "}
          <br />
          liability for the content and activities of these linked services.
          Nonetheless, we seek to protect the integrity of our service and
          welcome any feedback about these third-party services.
        </p>
      </section>

      {/* 4. How We Protect Your Information */}
      <section id="protect-info" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           How We Protect Your Information
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We implement a variety of security measures to maintain the safety of
          your personal information when you place an order or enter, submit, or
          access your personal information.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          All supplied sensitive/credit information is transmitted via Secure
          Socket Layer (SSL) technology and then encrypted into our Payment
          gateway provider's database, only to be accessible by those authorized
          with special access rights to such systems and are required to keep
          the information confidential.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          After a transaction, your full private information relating to any
          payment you make (such as financials, ID verifications, and other
          related data) is not stored on our servers.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          When you provide any personal information on any of our platforms, we
          will take reasonable precautions to secure that information and will
          only use that personal information in a way that this Privacy Policy
          permits.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We work hard to protect your personal information from unauthorized
          access, alteration, disclosure, or destruction of the information we
          hold. We restrict access to your personal information to our
          employees, contractors, and agents who need that information to
          process it. Anyone with this access is subject to strict contractual
          confidentiality obligations and may be disciplined or terminated or
          legally prosecuted if they fail to meet these obligations.
        </p>
      </section>

      {/* 5. How Long We Retain Your Information */}
      <section id="retain-info" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           How Long We Retain Your Information
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We will retain your information for as long as you use our services
          and for any additional period that we may be required or permitted by
          law.
        </p>
      </section>

      {/* 6. Know Your Rights */}
      <section id="rights" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           Know Your Rights
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We would like to make you fully aware of all your information
          protection rights. Unless the law provides otherwise, you have the
          following rights:
        </p>
        <br />
        <ul className="font-inter font-normal text-base leading-6 tracking-normal text-justify space-y-2 list-disc pl-6 text-content">
          <li>
            <strong>The right of access</strong> - you have the right to request from us copies
            of any personal information that we hold on you. We may charge a fee
            for this service.
          </li>
          <li>
          <strong>The right to rectification</strong> - you have the right to request that we
            correct any of your personal information you believe is inaccurate.
            You also have the right to request us to complete any of your
            personal information you believe is incomplete.
          </li>
          <li>
          <strong> The right to erasure</strong> - you have the right to request that we delete
            your personal information.
          </li>
          <li>
          <strong>The right to object</strong> - you have the right to object to our processing
            of your personal information.
          </li>
        </ul>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          If you would like to exercise any of these rights, please contact us
          using the information provided under the section titled “Get Help.”
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We comply with the requirements of the Data Protection Act, 2012, Act
          843, which prohibits the processing of data of a child under parental
          control in accordance with the law. (A child here refers to any person
          who is less than 18 years of age in accordance with the Children's
          Act, 1998, Act 560).
        </p>
      </section>

      {/* 7. Updating Our Privacy Policy */}
      <section id="cookie" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           Updating Our Privacy Policy
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We have the right to modify, update, or replace this Privacy Policy in
          whole or in any part at any time.
        </p>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          The current version of our Privacy Policy is always the version that
          is published on this website. You will be bound by the contents of
          this Privacy Policy on the day that you access our website. In the
          same way, you will be bound by the Terms of Service of this website
          when you agree to use our services. We encourage you to read our
          Privacy Policy carefully each time you use our service.
        </p>
      </section>

      {/* 8. Consent */}
      <section id="consent" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
          Consent
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          By using our site, you consent to our Privacy Policy. If we decide to
          change our Privacy Policy, we will post those changes on this page.
        </p>
      </section>

      {/* 9. Contact Us */}
      <section id="contact" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           Contact Us
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          If you have questions about this Privacy Policy, the information we
          hold about you, or would like to exercise one of the Data Protection
          Rights, please do not hesitate to contact us.
        </p>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          <b>
            Email us on:
              support@jumaconnect.com
          </b>
        </p>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          <b> WhatsApp us on: (+233) 536782829</b>
        </p>
      </section>

      {/* 10. Definitions */}
      <section id="definitions" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
          Definitions
        </h2>
        <br />

        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify  text-content">
          <b>Cookies</b> are small files containing a string of characters that
          is sent to your computer when you visit a website. When you visit the
          site again, the cookie allows that site to recognize your browser.
          Cookies may store user preferences and other information. You can
          configure your browser to refuse all cookies or to indicate when a
          cookie is being sent. However, some website features or services may
          not function properly without cookies.
        </p>
        <br />

        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify  text-content">
          <b>Data Collection Technologies</b> are technological methods used in
          collecting information such as crash reports, system activity, and the
          date, time, and referrer URL of your request, complaint or feedback.
          They may include cookies, flash cookies, device information, server
          logs and other technologies, pixel tags and web beacons.
        </p>
        <br />

        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          <b>IP Address</b> is the unique address that every device connected to
          the Internet is assigned a number known as an Internet Protocol (IP)
          address. These numbers are usually assigned in geographic blocks. An
          IP address can often be used to identify the location from which a
          device is connecting to the Internet.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          <b>GPS Location</b> is the Global Positioning System as set by the
          satellite-based radio-navigation feature available on most smartphone
          devices that provides information about your specific longitudinal and
          latitudinal location on the Earth's surface.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          <b>Metadata</b> is a set of data that describes and gives information
          about other data.
        </p>
      </section>

      {/* 11. Data Retention & Protection Policy */}
      <section id="data-protection" className="md: scroll-mt-[160px]">   
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           Data Retention & Protection Policy
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          This policy aims to inform you about how we collect and process any
          information that we collect from you, or that you provide to us. It
          covers information that could identify you (“personal information”)
          and information that could not. We do this in the context and in
          compliance with the Data Protection Act 2012 (DPA Act 843).
        </p>{" "}
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We are committed to protecting your data and the confidentiality of
          your personal information.
        </p>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We undertake to preserve the confidentiality of all information you
          provide to us and hope that you reciprocate.
        </p>{" "}
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          The Data Protection Act 2012 requires us to tell you about your rights
          and our obligations to you in regard to the processing and control of
          your personal data.
        </p>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          Except as set out below or in our terms of condition, we do not share,
          sell, or disclose to a third party any information collected through
          our website and services.
        </p>
      </section>

      {/* 12. Data Protection Officer */}
      <section id="protection-officer" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           Data Protection Officer
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We have appointed a data protection officer (DPO) who is responsible
          for ensuring that our policy is followed.
        </p>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          If you have any questions about this data retention and protection
          policy, including any requests to exercise your legal rights, please
          contact our DPO at support@jumaconnect.com.
        </p>
      </section>

      {/* 13. Data We Process */}
      <section id="data-we-process" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           Data We Process
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We may collect, use, store, and share personal data about you. We have
          collated these as follows:
        </p>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          <b>Your identity includes information such as:</b>
          <ul className="list-disc pl-6">
            <li>First name</li>
            <li>Last name</li>
            <li>
              Date of birth, and other identifiers that you may have provided at
              some time;
            </li>
          </ul>
        </p>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          <b>Your contact information includes information such as:</b>
          <ul className="list-disc pl-6">
            <li>Email address</li>
            <li>Telephone numbers</li>
            <li>Bank card details</li>
            <li>
              Any other information you have given to us for the purpose of
              processing your payments, communication.
            </li>
          </ul>
        </p>
      </section>

      {/* 14. Marketing */}
      <section id="marketing" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           Marketing
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We use data and content about our customers for invitations,
          promotions, and communications solely for promoting our services.
        </p>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We may aggregate anonymous data such as statistical or demographic
          data for any purpose. Anonymous Data is data that does not identify
          you as an individual. Aggregated data may be derived from your
          personal data but is not considered personal information in law
          because it does not reveal your identity.
        </p>
      </section>

      {/* 15. Information We Process Because We Have a Legal Obligation */}
      <section id="legal-obligation" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           Information We Process Because We Have a Legal Obligation
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          Sometimes, we must process your information in order to comply with a
          statutory obligation.
        </p>
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          For example, we may be required to give information to legal
          authorities if they so request or if they have the proper
          authorization such as a search warrant or court order. This may
          include your personal information.
        </p>
      </section>

      {/* 16. Data Protection Rights of Clients/Service Providers */}
      <section id="client-rights" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
           Data Protection Rights of Clients/Service Providers
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          You have several data protection rights that allow you to have control
          over how your personal data is processed. These rights include:
        </p>
        <ul className="font-inter font-normal text-base leading-6 tracking-normal text-justify space-y-2 list-disc pl-6 text-content">
          <li>
            <b>Right to be informed:</b> You have a right to be informed of what
            data of yours is being collected, how it's being used, how long it
            will be kept, and whether it will be shared with any third parties.
          </li>
          <li>
            <b>Right of access:</b> You have a right to request a copy of the
            information of yours that we hold.
          </li>
          <li>
            <b>Right of rectification:</b> You have the right to correct data
            that is inaccurate or incomplete.
          </li>
          <li>
            <b>Right to be forgotten:</b> Under certain circumstances, you have
            a right to ask us to erase any personal data of yours that we have
            stored.
          </li>
          <li>
            <b>Right of portability:</b> You have a right to request that we
            transfer any data that we hold on you to another company.
          </li>
          <li>
            <b>Right to restrict processing:</b> You have a right to request
            that we limit the way we use your personal data.
          </li>
          <li>
            <b>Right to object:</b> You have the right to challenge certain
            types of processing, such as direct marketing.
          </li>
        </ul>
      </section>

      {/* 17. Data Retention */}
      <section id="retention-period" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
         Retention period for personal data
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We shall not retain your data for a period longer than is necessary to
          achieve the purpose for which we process your data and in line with
          our retention policy. At the end of the retention period, your data
          will either be deleted completely or anonymized, for example by
          aggregation with other data so that it can be used in a
          non-identifiable way for statistical analysis and business planning.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          Specific details of the retention periods for different aspects of
          your personal data are available in our retention policy which you can
          request from us.
        </p>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          Where necessary, we may anonymize your personal data (so that it can
          no longer be associated with you) for research or statistical
          purposes. In those circumstances, we may use this information
          indefinitely without further notice to you.
        </p>
      </section>

      {/* 18. SSL Encryption */}
      <section id="encryption" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal  text-dark">
         Encryption of data
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify text-content">
          We use Secure Sockets Layer (SSL) certificates to verify our identity
          to your browser and to encrypt any data you provide. Whenever
          information is transferred between us, you can check that it is done
          so using SSL by looking for a closed padlock symbol or another trusted
          mark in your browser’s URL bar or toolbar.
        </p>
      </section>

      {/* 19. Policy Updates */}
      <section id="review-policy" className=" md: scroll-mt-[160px]">
        <h2 className="font-inter font-semibold text-lg leading-none tracking-normal text-dark ">
         Review of this data protection and retention policy
        </h2>
        <br />
        <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify mb-6 text-content">
          We may update this data protection and retention policy from time to
          time as necessary.
        </p>
      </section>
    </div>
  );
};

export default PolicyContent;
